import React from 'react';
import sanitizeHtml from 'sanitize-html';
import {
  DialogTitle,
  DialogActions,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { StyledDialog } from './index.style';

const NotificationDialogV4 = ({
  isPopupTransfer,
  contentPopup,
  image,
  hideImageOnMobileWeb,
  title,
  description,
  actionComponent,
  open,
  onClose,
  showIconClose = true,
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <StyledDialog
      isPopupTransfer={isPopupTransfer}
      hideImageOnMobileWeb={hideImageOnMobileWeb}
      open={open}
      onClose={handleClose}
    >
      {showIconClose && (
        <DialogTitle classes={{ root: 'dialog-title' }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            color="secondary"
            className="close-button"
          >
            <CloseRoundedIcon color="secondary" />
          </IconButton>
        </DialogTitle>
      )}
      <Box className="dialog-wrapper">
        <Box className="image-container">
          <img src={image} alt="icon" className="icon" />
        </Box>

        <Box className="content-wrapper">
          <DialogTitle classes={{ root: 'dialog-title' }}>
            <Typography className="title">{title}</Typography>
            <Box
              className="description"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(description, {
                  allowedTags: sanitizeHtml.defaults.allowedTags, // Giữ nguyên các thẻ mặc định
                  allowedAttributes: {
                    ...sanitizeHtml.defaults.allowedAttributes, // Giữ nguyên các thuộc tính mặc định
                    '*': ['style'], // Cho phép thuộc tính style trên tất cả các thẻ
                  },
                }),
              }}
            />
          </DialogTitle>
          {actionComponent && (
            <DialogActions classes={{ root: 'dialog-action' }}>
              {actionComponent}
            </DialogActions>
          )}
          {contentPopup && contentPopup}
        </Box>
      </Box>
    </StyledDialog>
  );
};

export default NotificationDialogV4;
